// extracted by mini-css-extract-plugin
module.exports = {"Data":"Element_Data__16k2q"};